import { DeviceConfigurationRequester } from '@cobliteam/api-lib';
import type { DeviceConfiguration, PageableContent, UpdateDeviceConfiguration } from '@cobliteam/common-types';
import { Environment } from '@cobliteam/react-environments';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'sonner';
import {
  loadDeviceConfigurationFailed,
  loadDeviceConfigurationSucceded,
  updateDeviceConfigurationFailed,
  updateDeviceConfigurationSucceded,
  updateDeviceSpeedFailed,
  updateDeviceSpeedSucceded,
} from './actionCreators';
import type { LoadDeviceConfigurationRequest, UpdateDeviceConfigurationRequestRequest, UpdateDeviceSpeedRequestRequest } from './actions';
import { ActionTypes } from './actionTypes';

const env = Environment.getInstance().getEnvironment();
const deviceConfigurationRequester = new DeviceConfigurationRequester({
  host: env.apiHost,
});

export function* requestDeviceConfigurationPage(action: LoadDeviceConfigurationRequest) {
  try {
    const { page, size, sort, deviceIds } = action.payload;
    const deviceConfigurationPage: PageableContent<DeviceConfiguration> = yield call(deviceConfigurationRequester.getDevicesConfiguration, page, size, sort, deviceIds);
    yield put(loadDeviceConfigurationSucceded(deviceConfigurationPage));
  } catch (err) {
    yield put(loadDeviceConfigurationFailed());
    toast.error('Houve um erro, tente novamente mais tarde.');
  }
}

export function* requestUpdateDeviceConfiguration(action: UpdateDeviceConfigurationRequestRequest) {
  try {
    const updatedDevicesConfiguration: UpdateDeviceConfiguration[] = yield call(deviceConfigurationRequester.postDevicesConfiguration, action.payload);
    yield put(updateDeviceConfigurationSucceded(updatedDevicesConfiguration));
  } catch (err) {
    yield put(updateDeviceConfigurationFailed());
    toast.error('Houve um erro, tente novamente mais tarde.');
  }
}

export function* requestUpdateDeviceSpeed(action: UpdateDeviceSpeedRequestRequest) {
  try {
    const updateVehicleSpeed = action.payload;
    yield call(deviceConfigurationRequester.postDevicesConfiguration, [updateVehicleSpeed]);
    yield put(updateDeviceSpeedSucceded(updateVehicleSpeed));
    toast.success('Avisos sonoros para Identificadores de Motoristas e Bloqueadores foram configurados com sucesso!');
  } catch (err) {
    yield put(updateDeviceSpeedFailed());
    toast.error('Houve um erro, tente novamente mais tarde.');
  }
}

export function* DeviceConfigurationSagasListener() {
  yield all([
    takeLatest(ActionTypes.LOAD_DEVICE_CONFIGURATION_REQUEST, requestDeviceConfigurationPage),
    takeLatest(ActionTypes.UPDATE_DEVICE_CONFIGURATION_REQUEST_REQUEST, requestUpdateDeviceConfiguration),
    takeLatest(ActionTypes.UPDATE_DEVICE_SPEED_REQUEST_REQUEST, requestUpdateDeviceSpeed),
  ]);
}
